import { useMutation, useQuery } from '@tanstack/react-query';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import {
  createManyPrograms,
  createProgram,
  deleteProgram,
  editProgram,
  getPrograms,
  getProgramsTypes
} from '../functions/program';

export const useGetProgramsTypes = () =>
  useQuery({
    queryKey: ['get-programs-types'],
    queryFn: () => getProgramsTypes()
  });

export const useGetPrograms = ({ nonProfitOrgId }: { nonProfitOrgId?: string }) =>
  useQuery({
    queryKey: ['get-programs'],
    queryFn: () => getPrograms(nonProfitOrgId),
    enabled: !!nonProfitOrgId
  });

export const useCreateProgram = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createProgram,
    mutationKey: ['create-program'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating program', e);
    }
  });
};

export const useEditProgram = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: editProgram,
    mutationKey: ['edit-program'],
    onError: (e: any) => {
      showError({});
      console.error('Error editing program', e);
    }
  });
};

export const useDeleteProgram = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: deleteProgram,
    mutationKey: ['deleteProgram'],
    onError: (e: any) => {
      showError({});
      console.error('Error deleting program', e);
    }
  });
};

export const useCreateManyPrograms = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createManyPrograms,
    mutationKey: ['create-many-programs'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating programs', e);
    }
  });
};
